import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {default as Cobrand} from "pages/cobrand";
import Page404 from "pages/error/404";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={"/cobrand"} replace={true}/>}/>
        <Route path="/cobrand" element={<Cobrand />}/>
        <Route path="*" element={<Page404 />}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
